// EnrollmentListTable.tsx
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
  Avatar,
  Stack,
} from '@mui/material';
import moment from 'moment';

interface Enrollment {
  firstName: string;
  lastName: string;
  email: string;
  city: string;
  phone: string;
}

interface EnrollmentListTableProps {
  data: Enrollment[];
  requestInfo: any;
  onApprove: (index: number) => void;
  onDeny: (index: number) => void;
  setCurrentEnrrol: (index: any) => void;
}

const EnrollmentListTable: React.FC<EnrollmentListTableProps> = ({
  data,
  requestInfo,
  setCurrentEnrrol,
}) => {
  const getInitials = (name = '') =>
    name
      .replace(/\s+/, ' ')
      .split(' ')
      .slice(0, 2)
      .map((v) => v && v[0].toUpperCase())
      .join('');

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#f8fafc' }}>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>Name</TableCell>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>Email</TableCell>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>City</TableCell>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>Phone</TableCell>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>Date Request</TableCell>
            <TableCell sx={{ py: 1.5, fontSize: '0.75rem', fontWeight: 600, color: '#64748b' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((customer, index) => (
            <TableRow
              hover
              key={customer.email}
              sx={{ 
                '&:hover': { bgcolor: '#f8fafc' },
                '&:last-child td': { borderBottom: 0 }
              }}
            >
              <TableCell sx={{ py: 1.5 }}>
                <Stack alignItems='center' direction='row' spacing={1.5}>
                  <Avatar 
                    sx={{ 
                      width: 28, 
                      height: 28, 
                      fontSize: '0.7rem',
                      bgcolor: '#e2e8f0',
                      color: '#64748b'
                    }}
                  >
                    {getInitials(customer.firstName)}
                  </Avatar>
                  <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                    {customer.firstName} {customer.lastName}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell sx={{ py: 1.5, fontSize: '0.8rem', color: '#64748b' }}>{customer.email}</TableCell>
              <TableCell sx={{ py: 1.5, fontSize: '0.8rem', color: '#64748b' }}>{customer.city}</TableCell>
              <TableCell sx={{ py: 1.5, fontSize: '0.8rem', color: '#64748b' }}>{customer.phone}</TableCell>
              <TableCell sx={{ py: 1.5, fontSize: '0.75rem', color: '#94a3b8' }}>
                {moment(requestInfo[index]?.date_created).format('YYYY-MM-DD hh:mm a')}
              </TableCell>
              <TableCell sx={{ py: 1.5 }}>
                <Button
                  size="small"
                  onClick={() => setCurrentEnrrol(customer)}
                  sx={{
                    bgcolor: '#1e293b',
                    color: 'white',
                    fontSize: '0.7rem',
                    px: 2,
                    py: 0.5,
                    minWidth: 'auto',
                    textTransform: 'uppercase',
                    '&:hover': { bgcolor: '#334155' }
                  }}
                >
                  Open
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default EnrollmentListTable;
